<modal-component class="_communication-template-example-component">
	<div right class="_container">
		<div class="_email-container" [innerHtml]="html"></div>
	</div>
</modal-component>
